import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React, { useCallback } from 'react';
import { ThemeProvider } from 'styled-components';
import ThemeSectionError from './error';
import getThemeSection from './getThemeSection';
import { jsx as _jsx } from "react/jsx-runtime";
function ThemeSection(_ref) {
  var name = _ref.name,
    withBackgroundImage = _ref.withBackgroundImage,
    children = _ref.children;
  var constructLocalTheme = useCallback(function (parentTheme) {
    if (!parentTheme) {
      throw new Error('ThemeSection must be used inside of a ThemeProvider component.');
    }
    if (!name && !withBackgroundImage) {
      return parentTheme;
    }
    var parentThemeSectionName = parentTheme.currentThemeSectionName;
    var resolvedName = name || parentThemeSectionName;
    var localThemeSection = getThemeSection({
      theme: parentTheme,
      name: resolvedName,
      withBackgroundImage: withBackgroundImage
    });
    if (!localThemeSection) {
      return parentTheme;
    }
    return _objectSpread(_objectSpread(_objectSpread({}, parentTheme), localThemeSection), {}, {
      currentThemeSectionName: resolvedName,
      parentThemeSectionName: parentThemeSectionName
    });
  }, [name, withBackgroundImage]);
  return /*#__PURE__*/_jsx(ThemeProvider, {
    theme: constructLocalTheme,
    children: children
  });
}
export { ThemeSectionError };
export default ThemeSection;